module.exports = __webpack_public_path__ + "media/images/529s/apple-touch-icon-4197ff375860c2c82b8126aa70604e1f.png";